import authRequest from "@/api/http/authRequest";


export default {
  search (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.get(`/admin/product/lesson/discount/search`, params, cb, errCb)
  },
  save (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.post(`/admin/product/lesson/discount`, params ,cb, errCb)
  },
  updateStatus (id: number, cb: (response) => void, errCb: (response) => any) {
    authRequest.put(`/admin/product/lesson/discount/${id}/status`, {} ,cb, errCb)
  },
  update (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.post(`/admin/product/lesson/discount/${params.id}`, params ,cb, errCb)
  },
  delete (id: number, cb: (response) => void, errCb: (response) => any) {
    authRequest.delete(`/admin/product/lesson/discount/${id}`, cb, errCb)
  },
  updatePrefixCode (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.patch(`/admin/product/lesson/discounts/code`, params ,cb, errCb)
  },
}
